import React, { useEffect, useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';
import * as styles from './PostStatus.module.scss';
import useAppSelector from '../app/redux/useAppSelector';
import addTestId from '../utils/addTestId';

const useSaveStatus = () => {
  const hasUnsavedChanges = useAppSelector(
    (state) => state.editor.unsaved.length() > 0,
  );
  const [isSaving, setIsSaving] = useState(hasUnsavedChanges);

  const debouncedSetIsSaving = useDebouncedCallback(setIsSaving, 500);
  useEffect(() => {
    // Prevent status flicker while typing
    debouncedSetIsSaving(hasUnsavedChanges);

    if (hasUnsavedChanges) {
      debouncedSetIsSaving.flush();
    }
  }, [hasUnsavedChanges, debouncedSetIsSaving]);

  return isSaving ? 'Saving…' : 'Saved';
};

const PostStatus = () => {
  const saveStatus = useSaveStatus();

  return (
    <div {...addTestId('postStatus')} className={styles.container}>
      {saveStatus}
    </div>
  );
};

export default PostStatus;
